import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import ClientSidenav from '../components/ClientSidenav';
import './UserProfile.css';

function UserProfile() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({ name: '', email: '' });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('user_data') || '{}');
    if (!userData.email) { navigate('/treinamentos'); return; }
    setUser(userData);
    setFormData({ name: userData.name || '', email: userData.email || '' });
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    try {
      const response = await api.put('/user/profile', formData, true);
      if (response.success) {
        const updatedUser = { ...user, ...formData };
        localStorage.setItem('user_data', JSON.stringify(updatedUser));
        setUser(updatedUser);
        setMessage('success');
        setTimeout(() => setMessage(''), 3000);
      }
    } catch (error) {
      setMessage('error:' + (error.message || 'Erro ao atualizar perfil'));
    } finally {
      setLoading(false);
    }
  };

  if (!user) return null;

  const userInitial = (user.name || user.fullName || '?').charAt(0).toUpperCase();

  return (
    <div className="user-profile-page">
      <ClientSidenav />

      <main className="profile-main">
        {/* Avatar hero */}
        <div className="profile-hero">
          <div className="profile-avatar-wrap">
            <div className="profile-avatar-ring">{userInitial}</div>
          </div>
          <div className="profile-name">{user.name || user.fullName}</div>
          <div className="profile-email-sub">{user.email}</div>
        </div>

        {/* Card */}
        <div className="profile-card">
          {message === 'success' && (
            <div className="profile-alert profile-alert-success">
              Perfil atualizado com sucesso!
            </div>
          )}
          {message.startsWith('error:') && (
            <div className="profile-alert profile-alert-error">
              {message.replace('error:', '')}
            </div>
          )}

          <form onSubmit={handleSubmit} className="profile-form">
            <div className="profile-field">
              <label>Nome Completo</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                placeholder="Digite seu nome completo"
                required
              />
            </div>
            <div className="profile-field">
              <label>E-mail</label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                placeholder="seu@email.com"
                required
              />
            </div>
            <div className="profile-actions">
              <button type="button" className="profile-btn-back" onClick={() => navigate('/treinamentos/cursos')}>
                ← Voltar
              </button>
              <button type="submit" className="profile-btn-save" disabled={loading}>
                {loading ? (
                  <><span className="profile-btn-spinner"/> Salvando...</>
                ) : (
                  'Salvar Alterações'
                )}
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
}

export default UserProfile;
